import React from 'react';
import { Navigate } from 'react-router-dom';

// RETIRED — /portal/loan-docs redirects to the dashboard. Its tasks are all
// covered on the organic self-serve path: the Owner Finance Contract IS the B-C
// Purchase and Sale Agreement (signed at option_period/under_contract), the Loan
// Estimate is signed at offer_accepted, and homeowner's insurance is handled at
// closing (HeroClosing). The backend write endpoints (/api/loan-docs/sign-*,
// insurance-*) reject with 410. The old page body (LoanDocsPage, imported by
// nothing) was deleted in cleanup Phase 1 (2026-10-28); the route stays as this
// redirect so old links and bookmarks still land somewhere.
export default function LoanDocs() {
  return <Navigate to="/dashboard" replace />;
}
